/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_ReingestInputs */

const es_tools_nexata_reingest = /** @type {(inputs: Tools_Nexata_ReingestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reindexando archivos...`)
};

const en_tools_nexata_reingest = /** @type {(inputs: Tools_Nexata_ReingestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reindexing files...`)
};

/**
* | output |
* | --- |
* | "Reindexing files..." |
*
* @param {Tools_Nexata_ReingestInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_reingest = /** @type {((inputs?: Tools_Nexata_ReingestInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_ReingestInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_reingest(inputs)
	return en_tools_nexata_reingest(inputs)
});
export { tools_nexata_reingest as "tools.nexata.reingest" }